/**
 * Bunny.net Icon Component
 * SVG-Vektorgrafik für Bunny.net Logo
 */

import React from 'react';

interface BunnyIconProps {
  className?: string;
  size?: number;
  color?: string;
}

export const BunnyIcon: React.FC<BunnyIconProps> = ({ 
  className = '', 
  size = 24,
  color = '#333'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 400 400"
      className={className}
      fill={color}
    >
      <g fill={color}>
        <path d="m268.243 115.65 91.1 49.691-83.739-112.265c-13.803 18.404-16.563 42.33-7.361 62.574z" className="st0"/>
        <path d="M226.834 298.77c11.042 0 20.244 9.203 20.244 21.165 0 11.043-9.202 20.245-21.165 20.245-11.042 0-20.244-9.202-20.244-20.245.92-11.042 10.122-21.164 21.165-21.164z"/>
        <path d="m164.26 69.64 253.976 138.03c6.442 2.761 8.282 10.123 5.521 16.564-.92 2.76-2.76 4.601-5.52 5.521-19.325 11.963-40.49 20.245-62.575 23.926L302.29 362.265s-16.563 37.728-62.574 23.005c19.325-19.324 42.33-36.808 42.33-66.255 0-31.287-24.846-56.132-56.133-56.132s-56.132 24.845-56.132 56.132c0 38.649 38.648 55.213 59.813 81.899 9.202 13.803 8.282 32.207-2.76 44.17-25.766-25.766-76.377-69.936-97.542-98.463-11.043-14.723-17.484-32.207-18.404-50.61 1.84-40.49 29.446-75.458 68.095-87.42 11.963-3.681 23.925-4.601 35.888-4.601 16.564.92 33.127 6.441 47.85 14.723 23.006 12.883 33.128 10.122 48.771-3.68 9.202-7.363 19.325-32.208 3.681-37.73-5.521-1.84-10.122-2.76-15.643-3.68-28.527-5.521-79.138-11.043-97.542-21.165-29.447-16.564-49.691-50.611-37.728-82.818z"/>
        <path d="M282.046 323.616zm0-3.68c11.963-61.654-50.611-120.547-99.382-112.266l3.68-.92c-2.76.92-5.52.92-7.361 1.84-38.649 11.963-66.255 46.931-68.095 87.42 0 18.404 6.441 36.808 18.404 50.611 21.165 28.527 71.776 72.697 98.462 99.383 11.042-11.963 12.883-30.367 2.76-44.17-22.085-26.686-59.813-43.25-59.813-81.899 0-31.286 24.846-56.132 56.133-56.132 31.287 0 56.132 24.846 55.212 56.132zM164.26 69.64l193.243 104.903 5.52 2.76c4.602 3.682 9.203 11.043 3.682 23.926-9.202 19.324-46.01 38.649-88.34 23.925 12.883 3.681 22.085-.92 34.048-10.122 9.202-7.362 19.324-32.207 3.68-37.728-5.52-1.84-10.122-2.76-15.643-3.681-28.526-5.521-79.138-11.043-97.542-21.165-30.367-16.564-50.611-50.611-38.648-82.818z"/>
        <path d="M164.26 69.64c20.244 73.616 141.711 80.058 202.445 110.424L164.26 69.64zM230.514 401.834c-21.164-26.686-59.813-43.25-59.813-81.899 0-28.526 21.165-51.531 48.77-55.212-44.169 0-80.057 35.888-80.057 80.978 0 5.521.92 11.043 1.84 16.564 17.484 20.244 43.25 43.25 64.415 63.494 8.282 7.362 16.564 15.644 22.085 21.165 5.521-6.442 8.282-13.803 9.202-22.085.92-8.282-1.84-16.564-6.442-23.005zM282.046 326.377v-6.442c11.963-61.653-51.532-120.546-99.382-112.265 10.122-2.76 21.164-3.68 31.287-2.76 63.494 1.84 81.898 69.935 68.095 121.467zM96.164 189.266c11.043 0 21.165 9.202 21.165 21.165v21.165H96.164C85.122 231.596 75 222.394 75 210.43c0-11.042 9.202-21.165 21.164-21.165z"/>
      </g>
    </svg>
  );
};

